import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-requisition',
  templateUrl: './requisition.component.html',
  styleUrls: ['./requisition.component.css']
})
export class RequisitionComponent implements OnInit {
    requisitionNo;

    public edit?: Edit;

    public saving = false;

    public cancelling = false;

    public deleting = false;

    public stockPlaceNameFromButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockget', gotoParms: () => this.edit!.stock_keyno_from ?? '' }];

    public stockPlaceNameToButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'stockget', gotoParms: () => this.edit!.stock_keyno_to ?? '' }];

    public orderButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderhead', gotoParms: () => this.edit!.order_internal_no ?? '' }];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.requisitionNo = this.stateService.getStateParams()['requisition_no'];
    }

    private async loadEdit() {
        if (!!this.requisitionNo) {
            this.edit = (await this.datatask.Post(762, { requisition_no: this.requisitionNo }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1356, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async cancelValues() {
        if (!!this.edit) {
            try {
                this.cancelling = true;

                const cancelConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (cancelConfirmed) {
                    await this.datatask.Post(1093, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.cancelling = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(763, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    requisition_no: string;
    stock_keyno_from: string;
    stock_keyno_to: string;
    requisitionstatus_id: string;
    requisitionstatus_name: string;
    stockplace_name_from: string;
    stockplace_name_to: string;
    prod_id: string;
    prod_name_long: string;
    requested_quantity: string;
    requested_quantity_sent: string;
    requested_quantity_received: string;
    show_delete: string;
    order_internal_no: string;
    order_order_no: string;
    show_cancel_rest: string;
    show_setting: string;
    may_change_qty: string;
}
